import React from 'react';
import { AppState } from '$/store';
import { connect } from 'react-redux';
import HeadBlock from '$/components/global/heading';
import HeadTab from '$/components/global/headingTab';
import { getIsCurrentUserSuperAdminState } from '$/store/profile/selectors';
import './index.scss';

export interface ICompanyProps {
  isSuperAdmin: boolean;
  children: React.ReactNode;
}

const Health: React.FC<ICompanyProps> = props => {
  const { isSuperAdmin, children } = props;

  const baseUrl = `/admin/health`;
  const plannerUrl = `${baseUrl}/planner`;

  return isSuperAdmin ? (
    <React.Fragment>
      <HeadBlock title={'Health Checks'}>
        <HeadTab title="Microsoft Planner" link={plannerUrl} exact={true} />
      </HeadBlock>
      <div>{children}</div>
    </React.Fragment>
  ) : null;
};

const mapStateToProps = (state: AppState) => {
  const { isSuperAdmin } = getIsCurrentUserSuperAdminState(state);

  return {
    isSuperAdmin,
  };
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Health);
